module.exports = __WEBPACK_EXTERNAL_MODULE__15__;